import { fetchBrokerVerificationBounds } from '../../../services/voucher/broker-verification-service';
import { SET_BROKER_VERIFICATION_BOUNDS } from '../action-types';
import { fetchCommercialProperty } from './voucher-actions';
import { fetchCompData } from './comp-data-actions';
import { fetchVoucherFiles } from '../deal-files-actions';

// `status` is 'ready' once every input of the "needs Voucher Verification" decision is in
// Redux, or 'failed' when the bounds request failed (the decision then routes through
// verification so an outage can't silently skip the broker check).
const setBrokerVerificationBounds = (voucherId, bounds) => ({
  type: SET_BROKER_VERIFICATION_BOUNDS,
  payload: { voucherId, status: bounds?.failed ? 'failed' : 'ready', data: bounds || null },
});

const setBrokerVerificationBoundsFailed = voucherId => ({
  type: SET_BROKER_VERIFICATION_BOUNDS,
  payload: { voucherId, status: 'failed', data: null },
});

// Loads what the decision needs when the Review page (which loads it itself) was not visited
// first, e.g. a browser refresh on the Voucher Verification tab. No-op if already loaded/loading.
const loadBrokerVerificationDecisionData = (dealId, voucherId) => (dispatch, getState) => {
  const current = getState().voucher?.brokerVerificationBounds;
  if (current?.voucherId === voucherId && current.status !== 'idle') return Promise.resolve();

  dispatch({
    type: SET_BROKER_VERIFICATION_BOUNDS,
    payload: { voucherId, status: 'loading', data: null },
  });

  const boundsRequest = dispatch(fetchCommercialProperty(dealId)).then((action) => {
    const primary = (action?.payload || []).find(p => p.location_type_new !== false) || null;
    return fetchBrokerVerificationBounds({ edpPropertyId: primary?.edp_property_id });
  });

  return Promise.all([
    boundsRequest,
    dispatch(fetchCompData({ deal: dealId })),
    // The commission agreement document is part of the decision.
    dispatch(fetchVoucherFiles({
      deal: dealId, ordering: '-modified', page: 1, page_size: 25,
    })),
  ])
    .then(([bounds]) => dispatch(setBrokerVerificationBounds(voucherId, bounds)))
    .catch(() => dispatch(setBrokerVerificationBoundsFailed(voucherId)));
};

export {
  loadBrokerVerificationDecisionData,
  setBrokerVerificationBounds,
  setBrokerVerificationBoundsFailed,
};
